import ReactDOM from 'react-dom';

//components
import ActivityFeedPopOut from  '@/components/page/activityFeed/ActivityFeedPopOut';



const ActivityFeedPopOutPortal = () => {
    const targetContainer = document.getElementById('react-activity-feed-popout-portal');

    if (targetContainer === null){
        return null;
    }
    return ReactDOM.createPortal(
        <ActivityFeedPopOut />, targetContainer
    );
};

export default ActivityFeedPopOutPortal;